const COOKIE_TOKEN_NAME = 'token';
const COOKIE_LANGUAGE_NAME = 'NEXT_LOCALE';
const COOKIE_CURRENCY_NAME = 'currency';
const COOKIE_LOCALITY_NAME = 'locality';
const COOKIE_FIRST_VISIT_NAME = 'firstVisit';
const COOKIE_IS_SUBSCRIBE_NAME = 'is_subscribe';
const COOKIE_NOTICE_NAME = 'COOKIENOTICE';
const COOKIE_CART_SESSION_ID = 'cart_session_id';
const COOKIE_REACTIVATE_CART_SESSION_ID = 'reactivate_cart_session_id';
const COOKIE_CHECKOUT_START = 'checkout_start';
const COOKIE_STOP_REDIRECT = 'rdflag';
const COOKIE_USER_REGION = 'user_region';
const COOKIE_PROMO_TAG = 'promo-tag';
const COOKIE_LANG_PREF = 'preferredLang';
const COOKIE_CURRENCY_PREF = 'preferredCurrency';
const COOKIE_AC_EMAIL = 'abandoned_cart_email';
const COOKIE_APPLIED_COUPON = 'applied_coupon';
// TODO: We should think about having a seperate constants file each for Marriott and Accor specific cookies
const COOKIE_ACCOR_AFFILIATE_PROGRAM_CODE = 'accor_affiliate_program_code';
const COOKIE_ACCOR_GTM_CART_TRACKING = 'accor_cart_gtm_tracking';
const COOKIE_TOKEN_MAX_AGE_SEC = 86400; // seconds
// Cookies that should not be restored in the cookieRestorer function from local storage
// - TODO: We should consider adding more cookies to this list, or possibly even excluding all first party cookies.
const NEVER_RESTORE_COOKIES = [COOKIE_CART_SESSION_ID, COOKIE_REACTIVATE_CART_SESSION_ID];

export { COOKIE_TOKEN_NAME as C, NEVER_RESTORE_COOKIES as N, COOKIE_LANGUAGE_NAME as a, COOKIE_CURRENCY_NAME as b, COOKIE_LOCALITY_NAME as c, COOKIE_FIRST_VISIT_NAME as d, COOKIE_IS_SUBSCRIBE_NAME as e, COOKIE_NOTICE_NAME as f, COOKIE_CART_SESSION_ID as g, COOKIE_REACTIVATE_CART_SESSION_ID as h, COOKIE_CHECKOUT_START as i, COOKIE_STOP_REDIRECT as j, COOKIE_USER_REGION as k, COOKIE_PROMO_TAG as l, COOKIE_LANG_PREF as m, COOKIE_CURRENCY_PREF as n, COOKIE_AC_EMAIL as o, COOKIE_APPLIED_COUPON as p, COOKIE_ACCOR_AFFILIATE_PROGRAM_CODE as q, COOKIE_ACCOR_GTM_CART_TRACKING as r, COOKIE_TOKEN_MAX_AGE_SEC as s };
//# sourceMappingURL=cookies-l-jEMp6P.js.map
